// Copyright 2025-2026 NXGN Management, LLC. All Rights Reserved.
import { createMaterialSymbolIcon } from '@/utils/material-symbol-icons'

export { createMaterialSymbolIcon }
export const Add = createMaterialSymbolIcon('add')
export const ArrowBack = createMaterialSymbolIcon('arrow_back')
export const Article = createMaterialSymbolIcon('article')
export const Business = createMaterialSymbolIcon('business')
export const CheckCircle = createMaterialSymbolIcon('check_circle')
export const ContentCopy = createMaterialSymbolIcon('content_copy')
export const Description = createMaterialSymbolIcon('description')
export const Group = createMaterialSymbolIcon('group')
export const Input = createMaterialSymbolIcon('input')
export const KeyboardArrowDown = createMaterialSymbolIcon('keyboard_arrow_down')
export const KeyboardArrowLeft = createMaterialSymbolIcon('keyboard_arrow_left')
export const KeyboardArrowRight = createMaterialSymbolIcon(
  'keyboard_arrow_right'
)
export const KeyboardDoubleArrowLeft = createMaterialSymbolIcon(
  'keyboard_double_arrow_left'
)
export const KeyboardDoubleArrowRight = createMaterialSymbolIcon(
  'keyboard_double_arrow_right'
)
export const List = createMaterialSymbolIcon('list')
export const Notes = createMaterialSymbolIcon('notes')
export const Search = createMaterialSymbolIcon('search')
export const Storage = createMaterialSymbolIcon('storage')
export const UploadFile = createMaterialSymbolIcon('upload_file')
export const WarningAmber = createMaterialSymbolIcon('warning_amber')
